import {
  Space,
  Button as AntdButton,
  Typography,
  Divider,
  Empty,
  Radio,
  Modal as AntdModal,
  Tooltip,
} from "antd";
import { Button } from "components/Buttons/Buttons";
import Modal from "components/Modal/Modal";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { BENEFIT_TYPE } from "utils/enums";
import moment from "moment";

import styles from "./styles.module.scss";

const { Text, Title } = Typography;

export default function WalletSelectPopup({
  visible,
  onCancel,
  onSuccess,
  wallets,
  isCustomerWalletsLoading,
  applicableWallets,
  selectedWalletId,
  isVoucherApplied,
  isRewardApplied
}) {
  const [selectedWallet, setSelectedWallet] = useState(null);

  const currentUser = useSelector((state) => state.user.currentUser);
  const hasDiscountManagementPermission = currentUser?.permissions?.find?.(
    (permission) => {
      return permission?.permissionName === "Discount Management";
    }
  );



  useEffect(() => {
    if (visible === false) {
      setSelectedWallet(null);
    } else {
      setSelectedWallet(selectedWalletId);
    }
  }, [visible]);

  const availableWallets = useMemo(() => {
    return wallets.filter((wallet) => {
      if (wallet.isGeneral == true) {
        return true;
      } else if (
        applicableWallets.find((promoWallet) => promoWallet.walletId === wallet.walletId)
      ) {
        return true;
      }
      return false;
    });
  }, [wallets, applicableWallets]);


  return (
    <Modal
      destroyOnClose={true}
      className=""
      title="Wallets List"
      headerBorder={true}
      visible={visible}
      onCancel={onCancel}
      okText="Save"
      onOk={() => {
        if (selectedWallet) {
          onSuccess(selectedWallet);
        } else {
          AntdModal.error({
            title: "Please select a wallet",
            maskClosable: true,
            content: "No wallet selected. Please select a wallet to proceed.",
          });
        }
      }}
    //   okButtonProps={{
    //     disabled: !initialValue || initialValue?.length <= 0,
    //   }}
    >
      <div>Available Wallets</div>

      <Radio.Group
        className={styles.checkboxContainer}
        onChange={(e) => {
          setSelectedWallet(e.target.value);
        }}
        value={selectedWallet}
      >
        {availableWallets.map((wallet) => {
          const isPromoWallet = !wallet?.isGeneral
          const isVoucherRestricted = isVoucherApplied && isPromoWallet && !hasDiscountManagementPermission ? "Promo wallet requires Discount Management Permission" : null
          // const isRewardRestricted = isRewardApplied && isPromoWallet ? "Promo wallet cannot be used with Programs/Membership Rewards" : null
          return (
            <Tooltip title={isVoucherRestricted} key={wallet.walletId}>
              <Radio
                value={wallet.walletId}
                className={styles.checkbox}
                disabled={isVoucherRestricted}
              >
                <span>{wallet?.isGeneral ? "General" : wallet?.programName}</span>
                &nbsp;
                <span>(${Math.abs(wallet?.balance ?? 0).toFixed(2)})</span>
              </Radio>
            </Tooltip>
          );
        })}
      </Radio.Group>
      <div></div>
    </Modal>
  );
}
